import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('apuracao', 'crescimento');
const gestaoApuracao = getBasePath('apuracao', 'gestao');

const apuracaoCrescimentoActions = {
  competencias: { method: 'GET', url: `${basePath}/competencias` },
  configuracao: { method: 'GET', url: `${basePath}/configuracao-apuracao` },
  pagina: { method: 'GET', url: `${basePath}/pagina?tamanhoPagina={size}&numeroPagina={page}` },
  salvar: { method: 'PUT', url: `${basePath}/salvar` },
  alterarRealizado: { method: 'PUT', url: `${basePath}/realizado` },
  resgatar: { method: 'PUT', url: `${basePath}/{idApuracao}/resgatar` },
  finalizar: { method: 'PUT', url: `${gestaoApuracao}/{idApuracao}/finalizar` },
  ajustar: { method: 'PUT', url: `${basePath}/{idApuracao}/ajustar` },
  validaEnvioFluxo: { method: 'GET', url: `${basePath}/{idApuracao}/valida-envio-fluxo` },
  registraUsuario: { method: 'PUT', url: `${gestaoApuracao}/{idApuracao}/registra/usuario` },
  simulaPagamento: { method: 'GET', url: `${basePath}/realizado/pagamento` },
  assinado: { method: 'GET', url: `${gestaoApuracao}/{idApuracao}/assinado` },
  contaCorrenteMeta: { method: 'GET', url: `${gestaoApuracao}/meta/conta_corrente` },
  contaCorrenteMetaMeses: { method: 'GET', url: `${gestaoApuracao}/meta/conta_corrente/meses` },
  planejadoDisponivel: { method: 'GET', url: `${gestaoApuracao}/meta/conta_corrente/{idContaCorrente}/planejado_disponivel` },
  salvarContratoCliente: { method: 'PUT', url: `${basePath}/atualizar/{id}/contrato_cliente/{codContratoCliente}` },
  enviarFilaApuracao: { method: 'POST', url: `${gestaoApuracao}/enviar-fila-apuracao` },
};

export default resource => resource(`${basePath}`, {}, apuracaoCrescimentoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/apuracao-crescimento.js